module.exports = __webpack_public_path__ + "media/application/images/2023/04_still-1450x816-be942d55c077acd572538856ddc89884.png";